import React from "react";
import Icons from "../../../../Config/Images"; // Default images from your config
import { BASE_URL } from "../../../../Constants/AppConstants";

const CustomImageComponent = ({
  src,
  alt = "",
  fallbackSrc = Icons.blank_image,
  height,
  width,
  backgroundColor,
  objectFit = "cover",
  style = {}, // Accept external styles
}) => {
  return (
    <img
      src={`${BASE_URL}${src}`}
      alt={alt}
      onError={(e) => {
        e.target.onerror = null; // Prevents looping if the fallback also fails
        e.target.src = fallbackSrc; // Sets default image if original fails
      }}
      style={{
        width: width,
        height: height,
        backgroundColor: backgroundColor,
        objectFit: objectFit,
        ...style,
      }}
    />
  );
};

export default CustomImageComponent;
